import { ServiceResponse } from "../../api/ServiceResponse";
import { PumpDto } from "./PumpDto";

export class PumpResponse extends ServiceResponse {
  pumpList?: PumpDto[];
  count?: number;

  constructor(init?: Partial<PumpResponse>) {
    super(init);
    Object.assign(this, init);
  }

  // Getters & Setters
  getPumpList(): PumpDto[] | undefined {
    return this.pumpList;
  }
  setPumpList(value: PumpDto[] | undefined): void {
    this.pumpList = value;
  }

  getCount(): number | undefined {
    return this.count;
  }
  setCount(value: number | undefined): void {
    this.count = value;
  }
}
